import type {CandidateEvaluationState} from 'src/types/candidate-evaluation';
import type {NodeSchedule} from 'src/types/node-schedule';

import type {Dispatch, ThunkAction} from 'src/reducers';

import * as reduxApiBff from 'src/utils/redux-api-bff';

import {parseCandidateEvaluation} from 'src/utils/candidate-evaluation';


export const RECEIVE_CANDIDATE_EVALUATION_INFO = 'candidate-evaluation/receive';
export const UPDATE_CANDIDATE_EVALUATION_INFO = 'candidate-evaluation/update';
export const UPDATE_NODE_SCHEDULE = 'candidate-evaluation/update-node-schedule';
export const RESET_CANDIDATE_EVALUATION_INFO = 'candidate-evaluation/reset';

export type CandidateEvaluationPayload = Partial<CandidateEvaluationState>;

type ReceiveCandidateEvaluationInfo = {
  type: typeof RECEIVE_CANDIDATE_EVALUATION_INFO;
  payload: CandidateEvaluationPayload;
};

type UpdateCandidateEvaluationInfo = {
  type: typeof UPDATE_CANDIDATE_EVALUATION_INFO;
  payload: CandidateEvaluationPayload;
};

type UpdateNodeScheduleAction = {
  type: typeof UPDATE_NODE_SCHEDULE;
  payload: Partial<NodeSchedule>;
};

type ResetStateAction = {
  type: typeof RESET_CANDIDATE_EVALUATION_INFO;
};

export type CandidateEvaluationAction =
  | ReceiveCandidateEvaluationInfo
  | UpdateCandidateEvaluationInfo
  | UpdateNodeScheduleAction
  | ResetStateAction;

export const receiveCandidateEvaluationInfo = (
  payload: CandidateEvaluationState,
): ReceiveCandidateEvaluationInfo => ({
  type: RECEIVE_CANDIDATE_EVALUATION_INFO,
  payload,
});

export const updateCandidateEvaluationInfo = (
  payload: CandidateEvaluationPayload,
): UpdateCandidateEvaluationInfo => ({
  type: UPDATE_CANDIDATE_EVALUATION_INFO,
  payload,
});
export const updateNodeSchedule = (
  payload: Partial<NodeSchedule>,
): UpdateNodeScheduleAction => ({
  type: UPDATE_NODE_SCHEDULE,
  payload,
});

export const resetCandidateEvaluationInfo = (): ResetStateAction => ({
  type: RESET_CANDIDATE_EVALUATION_INFO,
});

export const getCandidateEvaluationTaskNode: (
  node_id: string,
) => ThunkAction<unknown> = (node_id) => async (dispatch: Dispatch) => {
  const fetchedNodeResponse = await dispatch(
    reduxApiBff.get(`node/composite`, {
      node_id,
    }),
  );
  const parsedCandidateEvaluationNode = parseCandidateEvaluation(
    fetchedNodeResponse.body,
  );

  return dispatch(
    receiveCandidateEvaluationInfo(parsedCandidateEvaluationNode),
  );
};
